import type {ButtonHTMLAttributes} from 'react';

interface ButtonPropsType extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  className?: string;
}

export default function Button({text, className, ...props}: ButtonPropsType) {
  return (
    <div className="h-full rounded-lg border-b-2 border-[#D9D9D9]">
      <button
        style={{
          textShadow: !props.disabled
            ? '1.2px 1.2px 0px rgba(0, 0, 0, 0.3)'
            : 'none',
        }}
        className={`h-full rounded-lg border-2 border-[#6B2D1A] px-[8px] text-[12px] ${props.disabled ? 'bg-[white] text-[#6B2D1A]' : 'bg-[#FF6535] text-white'} ${className}`}
        {...props}>
        {text}
      </button>
    </div>
  );
}
